<template>
  <div class="row py-3 m-1 mb-3 d-flex d-lg-none d-xl-none d-md-none">
    <div class="col-6 d-flex flex-column p-0">
      <span class="details-label">
        Carrier
      </span>
      <span class="details-content mb-4" v-if="job.carrier">
        {{ job.carrier.name }}
      </span>
      <span class="details-content mb-4" v-else>
        -
      </span>
      <span class="details-label">
        Assigned to
      </span>
      <span class="details-content">
        {{ job.cluster_user && job.cluster_user.username ? job.cluster_user.username : '-' }}
      </span>
    </div>
    <div class="col-6 p-0">
      <div class="d-flex flex-column p-0">
        <div class="d-flex align-items-center justify-content-end movers-wrap">
          <i class="fa fa-home pr-3"
             :class="job.is_small === 1 ? 'icon-color': 'icon-color2'"
          />
          <div class="movers-number d-flex flex-column">
            <div class="movers btn-status mb-1" :class="[
              job.movers === job.assigned_movers.length ? 'turquoise-border-text' : 'orange-yellow-border-text',
              job.assigned_movers.length === 0 ? 'red-border-text' : '',
            ]"
            >
              <span>
                {{ job.assigned_movers.length }}/{{ job.movers }}
              </span>
            </div>
            <div class="trucks btn-status" :class="[
              job.trucks === job.assigned_trucks.length ? 'turquoise-border-text' : 'orange-yellow-border-text',
              job.assigned_trucks.length === 0 ? 'red-border-text' : '',
            ]"
            >
              <span>
                {{ job.assigned_trucks.length }}/{{ job.trucks }}
              </span>
            </div>
          </div>
        </div>
        <span class="details-label">
          Move date
        </span>
        <span class="details-content">
          {{ job.move_date }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    tooltipDay: {
      type: String,
      default: () => '',
    },
    showTrucks: [],
  }),
};
</script>
<style lang="scss" scoped>
.details-label {
  display: flex !important;
  font-weight: 500;
  font-size: 12px;
  color: #4c5669;
  margin-bottom: 10px;
}
.details-content {
  font-size: 13px;
  color: #4c5669;
}
.movers-wrap {
  margin-bottom: 32px;
}
.fa-home {
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobDetails.vue